import api, { TipoOptions } from './api';



export const getAllDisciplicaProjetos = () => api.get<TipoOptions[]>('disciplicaProjetos');